import { createReducer } from 'lib/redux/reducerUtils'

export const initialLoyaltyState: App.LoyaltyState = {}

export default createReducer<App.LoyaltyState>(initialLoyaltyState, {})
